import React from "react"
import {TextMedium} from "../../text/text"
import styles from "../form-single-select/form-single-select.module.scss"
import {TextMessage} from "../../text/text"
import {ValidationResult} from "../../../util/validation/validation-result"

export interface FormFieldProps {
  label: string
  readonly showValidity?: boolean
  readonly validationResult?: ValidationResult
}

export const FormField: React.FC<FormFieldProps> = ({label, showValidity, validationResult, children}) => {
  return <div>
    <label>
      <TextMedium>{label}</TextMedium>
      {children}
    </label>

    <span hidden={!showValidity || validationResult == null || validationResult.valid} className={styles.ErrorMessage}>
      <TextMessage color="crimson-red">{validationResult == null ? "" : validationResult.errorMessage}</TextMessage>
    </span>
  </div>
}
